import list_icon from '@/assets/img/device/nd68/icon.png'
import { Mars68 } from './mars68'
import { EffectIndex, KK } from '@/define/define'
import { LightEffectModeType } from '@/define/light'

export class Mars68SE extends Mars68 {
  name: string = 'Mars68SE'
  icon: string = list_icon
  width: number = 640

  lightEffectList: { [name: LightEffectModeType]: EffectIndex } = {}

  fnDisableKeys: KK[] = [
    0x1, 0x7, 0xd, 0x13, 0x19, 0x1f, 0x25, 0x2b, 0x31, 0x37, 0x3d, 0x43, 0x49,
    // 0x4f, // backspace
    // 0x44, [{
    // 0x4a, }]
    0x9, 0xf,
    // 0xb,   win
    // 0x59,   →
    0x5e, 0x5f,
    // 0x52,   ↑
    // 0x4d,   ←
    // 0x53,   ↓
    0x65, 0x3b,
  ]
}
